import type { ShoeWidth } from '~/api/aspida/@types';

export const SegmentedImageLabel = <const>{
  Left: 'Left',
  Right: 'Right',
};

export const footSize = ['Narrow', 'Standard', 'Wide', 'Extra Wide'] as const;

export const getFootSizeByFootSizeEnum = (index: ShoeWidth): FootSize => {
  return footSize[index - 1];
};

export type SegmentedImageLabel = (typeof SegmentedImageLabel)[keyof typeof SegmentedImageLabel];
export type FootSize = (typeof footSize)[number];
